import { render, staticRenderFns } from "./AS_DuplicateReceipt.vue?vue&type=template&id=0a704d12&scoped=true&"
import script from "./AS_DuplicateReceipt.vue?vue&type=script&lang=js&"
export * from "./AS_DuplicateReceipt.vue?vue&type=script&lang=js&"
import style0 from "./AS_DuplicateReceipt.vue?vue&type=style&index=0&id=0a704d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a704d12",
  null
  
)

export default component.exports